export default "__VITE_ASSET__Bh$9pQC2__"